import { DigLitSelfAssessmentResult } from "src/app/_models/DigitalLiteracy";

export interface DigLitSelfAssessmentState {
	data: DigLitSelfAssessmentResult;
	currentPage: number;
	loader: boolean;
	saveResult: boolean;
	isDirty: boolean;
	error: any;
}

export const initialDigLitSelfAssessmentState : DigLitSelfAssessmentState = {
	data: null,
	currentPage: 0,
	loader: false,
	saveResult: null,
	isDirty: false,
	error: null,
}